import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
    Box,
    Container,
    Typography,
    Paper,
    IconButton,
    Snackbar,
    Alert,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Link
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { getWorkspaceSettings } from './firebaseService';

const WorkspaceUrls = () => {
    const { workspaceId } = useParams();
    const [workspaceName, setWorkspaceName] = useState('');
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');

    useEffect(() => {
        const fetchWorkspaceSettings = async () => {
            try {
                const settings = await getWorkspaceSettings(workspaceId);
                if (settings) {
                    setWorkspaceName(settings.name);
                }
            } catch (error) {
                console.error('Error fetching workspace settings:', error);
            }
        };

        fetchWorkspaceSettings();
    }, [workspaceId]);

    const baseUrl = window.location.origin;
    const urls = [
        {
            name: '메시지 보드',
            description: '방문자들이 메시지를 볼 수 있는 페이지입니다.',
            url: `${baseUrl}/${workspaceId}`
        },
        {
            name: '메시지 작성',
            description: '방문자들이 메시지를 작성할 수 있는 페이지입니다.',
            url: `${baseUrl}/${workspaceId}/write`
        },
        {
            name: '메시지 승인',
            description: '관리자가 메시지를 승인할 수 있는 페이지입니다.',
            url: `${baseUrl}/${workspaceId}/messages`
        },
        {
            name: '메시지 삭제',
            description: '관리자가 메시지를 삭제할 수 있는 페이지입니다. 메시지를 누르면 삭제버튼이 보입니다',
            url: `${baseUrl}/${workspaceId}?admin=true`
        }
    ];

    const handleCopy = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            setSnackbarMessage('URL이 복사되었습니다!');
            setOpenSnackbar(true);
        });
    };

    return (
        <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
            <Typography variant="h4" gutterBottom align="center" sx={{ mb: 4 }}>
                {workspaceName} URL 정보
            </Typography>

            <TableContainer component={Paper} sx={{ mb: 4 }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>페이지</TableCell>
                            <TableCell>설명</TableCell>
                            <TableCell>URL</TableCell>
                            <TableCell align="center">복사</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {urls.map((item) => (
                            <TableRow key={item.name}>
                                <TableCell component="th" scope="row">
                                    <Typography variant="subtitle1">{item.name}</Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="body2" color="text.secondary">
                                        {item.description}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Box
                                        component="div"
                                        sx={{
                                            maxWidth: '200px',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap'
                                        }}
                                    >
                                        <Link 
                                            href={item.url} 
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                            sx={{ 
                                                textDecoration: 'none',
                                                '&:hover': {
                                                    textDecoration: 'underline'
                                                }
                                            }}
                                        >
                                            {item.url}
                                        </Link>
                                    </Box>
                                </TableCell>
                                <TableCell align="center">
                                    <IconButton
                                        onClick={() => handleCopy(item.url)}
                                        size="small"
                                        color="primary"
                                    >
                                        <ContentCopyIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Snackbar
                open={openSnackbar}
                autoHideDuration={2000}
                onClose={() => setOpenSnackbar(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert onClose={() => setOpenSnackbar(false)} severity="success">
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </Container>
    );
};

export default WorkspaceUrls; 